import { Suspense } from 'react'
import { Outlet } from 'react-router-dom'

import TopBar from './topBar/TopBar'
import SideNav from './sideBar/SideNav'
import FootBar from './footBar/FootBar'
import  Loading  from '../../loading/Loading'
import MobileSideNav from './sideBar/MobileSideNav'

export const AppLayout = () => {
  return (
    <div className="ph-app">
      <SideNav />
      <MobileSideNav />
      <TopBar />
      <main className="ph-main">
        <Suspense fallback={<Loading />}>
          <Outlet />
        </Suspense>
      </main>
      <FootBar />
    </div>
  )
}
